import { render } from "./B2bTableLinesRecadvsReceived.vue?vue&type=template&id=5eb552ec&scoped=true&lang=pug"
import script from "./B2bTableLinesRecadvsReceived.vue?vue&type=script&lang=js"
export * from "./B2bTableLinesRecadvsReceived.vue?vue&type=script&lang=js"

import "./B2bTableLinesRecadvsReceived.vue?vue&type=style&index=0&id=5eb552ec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb552ec"]])

export default __exports__